import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
// import "./AddNewLiveStream.css";
import Select from "react-select";
import { Modal, Form, Table } from 'react-bootstrap';
import { toast } from "react-toastify"
import Button from "@mui/material/Button";
import { TagsInput } from "react-tag-input-component";
import JoditEditor from "jodit-react";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import facebook from "../../../components/Images/liveicon/facebook.png";
import twitter from "../../../components/Images/liveicon/twitter.png";
import youtube from "../../../components/Images/liveicon/youtube.png";
import useCompressImageConfig from "../../../components/CommonApis/Compressimageapi";
import usePpvGlobalImageConfig from "../../../components/CommonApis/ppv_global_change";


import { getItemToken } from "../../../Utils/localStorageUtils";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import AdminCustomArea from "../../../components/CommonComponents/AdminCustomArea";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomRadio from "../../../components/CommonComponents/AdminCustomRadio";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminGalleryModal from "../../../components/CommonComponents/AdminGalleryModal";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminVideoPlayer from "../../../components/CommonComponents/AdminVideoPlayer";
import AdminYoutubePlayer from "../../../components/CommonComponents/AdminYoutubePlayer";
import AdminProcessButton from "../../../components/CommonComponents/AdminProcessButton";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import { IoClose } from "react-icons/io5";
import { MdWifiTethering, MdInfo, MdAddCircle } from "react-icons/md";
import { RiFileCopyLine } from "react-icons/ri";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import { navigateChecker } from "../../../components/navigateChecker";
import { connect } from "react-redux";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import AdminAIModal from "../../../components/CommonComponents/AdminAImodal";
import AdminCustomURLCopy from "../../../components/CommonComponents/AdminCustomURLCopy";
import RadioStationCategoryAddEdit from "./RadioStationCategoryAddEdit";

const AddEditRadioStation = ({ languageCodeData, siteTheme }) => {

    const { handleFileChangeProvider, uploadingFiles, buildDynamicSubText, validateOrientationBySlug, validateImageRatio, globalImageUplaodAPI, fetchRequest } = useMyContext()
    const { compressResolutionFormat } = useCompressImageConfig();
    const { allCurrencylistfromappi, globalPpvStatusActive } = usePpvGlobalImageConfig();


    const baseURL = process.env.REACT_APP_Baseurl
    const headers = getItemToken('access_token');
    const { id } = useParams();
    const labelSource = 'radio-station'
    const uploadFileApi = `${baseURL}/admin/library/upload?upload_type=audio&clone_to=audio`
    const createApi = `${baseURL}/admin/radio-station/create`
    const addApi = `${baseURL}/admin/radio-station/store`
    const editApi = `${baseURL}/admin/radio-station/edit`
    const updateApi = `${baseURL}/admin/radio-station/update`
    const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
    const liveUploadFile = `${baseURL}/admin/radio-station/video-upload`
    const imageApi = globalImageUplaodAPI()
    const moveApi = `${baseURL}/admin/livestream/move`
    const assignApi = `${baseURL}/admin/radio-station/assignto`
    const updatePPV = `${baseURL}/admin/radio-station/PayPerViewPrice/StoreUpdate`
    const generateAISuggestionApi = `${baseURL}/admin/ai-prompt-response`
    const [modalTarget, setModalTarget] = useState(null);
    const [defaultPrompt, setDefaultPrompt] = useState("");
    const [loading, setLoading] = useState(true);


    const [customFieldValues, setCustomFieldValues] = useState({})
    const combinedRef = useRef({
        title: null,
        slug: null,
        age_restrict: null,
        selected_categories: null,
        access: null,
        url_type: null,
        website_URL: null,
        mp3_url: null,
        m3u_url: null,
        acc_audio_url: null,
        embed_url: null,
        image: null,
        player: null,
        tv: null,
        player_cover: null,
        free_duration_time: null,
        duration: null,
        donations_label: null,
        year: null,
        publish_time: null,
        ppv_price: null,
        ios_ppv_price: null,
        description: null,
        details: null,
        Meta_description: null,
        website_page_title: null,
        rating: null

    });

    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        state: "formData",
        title: "",
        slug: "",
        url_type: '',
        selected_categories: [],
        tv: "",
        image: "",
        player: "",
        age_restrict: 0,
        rating: 0,
        publish_type: "publish_now",
        free_duration_status: 0,
        enable_Tips: 0,
        enable_restream: 0,
        global_ppv: 0,
        global_ios_ppv: 0,
        stream_id: '',
        active: 0,
        record_enable: 0,
        year: new Date().getFullYear(),
        access: "guest",
        schedule_programs: [{
            id: Date.now(),
            name: "",
            description: "",
            start_time: "",
            end_time: "",
            days: "",
            selectedDays: [],
            image: ""
        }]
    })

    const [defaultOption, setDefaultOption] = useState({
        state: "defaultOption",
        artistsOption: [],
        categoryOption: [],
        languageOption: [],
        blockCountryOption: [],
        availableCountryOption: [],
        liveSourceOption: [],
        ageOption: [],
        albumOption: [],
        accessOption: [],
        iosOption: [],
        lyricsOption: [],
        globalOption: null,
    })

    const [labelDisplay, setLabelDisplay] = useState([]);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [modelClose, setModelClose] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const [formDataError, setFormDataError] = useState({})
    const [coverImageFile, setCoverImageFile] = useState(null);
    const [playerImageFile, setPlayerImageFile] = useState(null);
    const [tvImageFile, setTvImageFile] = useState(null);
    const [playerCoverImageFile, setPlayerCoverImageFile] = useState(null);
    const [liveVideo, setLiveVideo] = useState(null);
    const [showOverlay, setShowOverlay] = useState(false);
    const [galleryModal, setGalleryModal] = useState(false)
    const [categoryModal, setCategoryModal] = useState(false)
    const [selectedIds, setSelectedIds] = useState([]);
    const [pricemodel, setPriceModel] = useState(false);
    const [getGeofencing, setGetGeoFencing] = useState(null);
    const [getGeofencingAvailableCountries, setGetGeoFencingAvailableCountries] = useState(null);
    const [page_for, setPageFor] = useState();
    const [checkFileUpload, setCheckFileUpload] = useState(false);
    const [uploadLiveId, setUploadLiveId] = useState();
    const [moveVideo, setMoveVideo] = useState(false);
    const [scheduleImageFiles, setScheduleImageFiles] = useState({});
    const [convertPrice, setConvertPrice] = useState({
        source_type: 2,
        PPVType: "",
        PriceType: "",
        ActualPrice: "",
        IOSPrice: "",
        convertedPriceRates: []
    })

    const currentYear = new Date().getFullYear();

    const years = Array.from({ length: currentYear - 1895 + 1 }, (_, index) => ({ name: 1895 + index, value: 1895 + index }));

    const handleClearSelectFile = (value) => {
        if (value == 'image') {
            setCoverImageFile(null)
        }
        if (value == 'tv') {
            setTvImageFile(null)
        }
        if (value == 'player') {
            setPlayerImageFile(null)
        }
        if (value == 'player_cover') {
            setPlayerCoverImageFile(null)
        }
        if (value == 'live_video') {
            setLiveVideo(null)
            setFormData((prev) => ({
                ...prev,
                ['live_video']: ""
            }))
        }
        setFormDataError((prev) => ({
            ...prev,
            [value]: ""
        }))

    }


    const handleFileChange = async (event) => {
        const { files, name, value, accept, dataset } = event.target;
        const checkSize = compressResolutionFormat?.live == "1";
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));

        if (files?.length > 0) {
            const newFile = files[0];

            // Image type validation for image files
            if (name !== 'live_video' && !allowedTypes.includes(files[0]?.type)) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Only JPG, JPEG, WEBP and PNG files are allowed.",
                }));
                if (name === 'image') setCoverImageFile(null);
                if (name === 'player') setPlayerImageFile(null);
                if (name === 'tv') setTvImageFile(null);
                if (name === 'player_cover') setPlayerCoverImageFile(null);
                if (combinedRef.current[name]) {
                    combinedRef.current[name].focus();
                }
                return;
            }

            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            };
            const fileContent = await readFile(newFile);

            if (name == 'image') {
                setCoverImageFile(newFile);
                if (dataset?.orientation) {
                    const result = await validateOrientationBySlug(newFile, dataset.orientation);
                    if (!result.ok) {
                        let msg = 'Selected image does not match the required orientation.';
                        if (result?.expected) {
                            const ratio = `${result.expected.width}:${result.expected.height}`;
                            msg = `Image must be in ${result?.ratio || ratio} Ratio or ${result.expected.width}x${result.expected.height}px`;
                        }
                        setFormDataError((prev) => ({ ...prev, [name]: msg }));
                        setCoverImageFile(null);
                        if (combinedRef.current[name]) {
                            combinedRef.current[name].focus();
                        }
                        return;
                    }
                } else {
                    const isValidSize = await validateImageRatio(newFile, 2 / 3, 1080, 1620);
                    if (!isValidSize) {
                        setFormDataError((prev) => ({ ...prev, [name]: "Image must be in 2:3 Ratio or 1080x1620px." }));
                        setCoverImageFile(null);
                        if (combinedRef.current[name]) {
                            combinedRef.current[name].focus();
                        }
                        return;
                    }
                }
            }

            if (name == 'player') {
                setPlayerImageFile(newFile);
                if (dataset?.orientation) {
                    const result = await validateOrientationBySlug(newFile, dataset.orientation);
                    if (!result.ok) {
                        let msg = 'Selected image does not match the required orientation.';
                        if (result?.expected) {
                            const ratio = `${result.expected.width}:${result.expected.height}`;
                            msg = `Image must be in ${result?.ratio || ratio} Ratio or ${result.expected.width}x${result.expected.height}px`;
                        }
                        setFormDataError((prev) => ({ ...prev, [name]: msg }));
                        setPlayerImageFile(null);
                        if (combinedRef.current[name]) {
                            combinedRef.current[name].focus();
                        }
                        return;
                    }
                } else {
                    const isValidSize = await validateImageRatio(newFile, 16 / 9, 1280, 720);
                    if (!isValidSize) {
                        setFormDataError((prev) => ({ ...prev, [name]: "Image must be in 16:9 Ratio or 1280x720px." }));
                        setPlayerImageFile(null);
                        if (combinedRef.current[name]) {
                            combinedRef.current[name].focus();
                        }
                        return;
                    }
                }
            }

            if (name == 'tv') {
                setTvImageFile(newFile);
                if (dataset?.orientation) {
                    const result = await validateOrientationBySlug(newFile, dataset.orientation);
                    if (!result.ok) {
                        let msg = 'Selected image does not match the required orientation.';
                        if (result?.expected) {
                            const ratio = `${result.expected.width}:${result.expected.height}`;
                            msg = `Image must be in ${result?.ratio || ratio} Ratio or ${result.expected.width}x${result.expected.height}px`;
                        }
                        setFormDataError((prev) => ({ ...prev, [name]: msg }));
                        setTvImageFile(null);
                        if (combinedRef.current[name]) {
                            combinedRef.current[name].focus();
                        }
                        return;
                    }
                } else {
                    const isValidSize = await validateImageRatio(newFile, 16 / 9, 1280, 720);
                    if (!isValidSize) {
                        setFormDataError((prev) => ({ ...prev, [name]: "Image must be in 16:9 Ratio or 1280x720px." }));
                        setTvImageFile(null);
                        if (combinedRef.current[name]) {
                            combinedRef.current[name].focus();
                        }
                        return;
                    }
                }
            }

            if (name == 'player_cover') {
                setPlayerCoverImageFile(newFile);
                if (dataset?.orientation) {
                    const result = await validateOrientationBySlug(newFile, dataset.orientation);
                    if (!result.ok) {
                        let msg = 'Selected image does not match the required orientation.';
                        if (result?.expected) {
                            const ratio = `${result.expected.width}:${result.expected.height}`;
                            msg = `Image must be in ${result?.ratio || ratio} Ratio or ${result.expected.width}x${result.expected.height}px`;
                        }
                        setFormDataError((prev) => ({ ...prev, [name]: msg }));
                        setPlayerCoverImageFile(null);
                        if (combinedRef.current[name]) {
                            combinedRef.current[name].focus();
                        }
                        return;
                    }
                } else {
                    const isValidSize = await validateImageRatio(newFile, 1 / 1, 1080, 1080);
                    if (!isValidSize) {
                        setFormDataError((prev) => ({ ...prev, [name]: "Image must be in 1:1 Ratio or 1080x1080px." }));
                        setPlayerCoverImageFile(null);
                        if (combinedRef.current[name]) {
                            combinedRef.current[name].focus();
                        }
                        return;
                    }
                }
            }

            if (name === 'live_video') {
                setLiveVideo(newFile);
                setFormData((prev) => ({
                    ...prev,
                    "live_video": newFile
                }));
            }
        }
    };

    const multiSelectLabel = (array, valueKey, labelKey) => {
        return Array.isArray(array) ? array?.map((item) => ({
            value: item[valueKey],
            label: item[labelKey]
        })) : [];
    };

    const fetchData = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${editApi}/${id}`, { headers: headers });

            const result = response?.data?.data;
            setGetGeoFencing(result?.getGeofencing);
            setGetGeoFencingAvailableCountries(result?.getGeofencingAvailableCountries);
            const previousFormData = result?.livestream;
            setDefaultOption(prev => ({
                ...prev,
                accessOption: result?.user_access
            }))

            const updatedFormData = {
                ...previousFormData,
                access: previousFormData.access || "guest",
                selected_artists: multiSelectLabel(previousFormData?.Selected_artists, 'id', 'artist_name'),
                selected_categories: previousFormData?.Selected_RadioStationCategory?.map(c => c.id) || [],
                selected_Languages: multiSelectLabel(previousFormData?.Selected_Languages, 'id', 'name'),
                selected_blocked_country: multiSelectLabel(previousFormData?.Selected_Block_coutries, 'id', 'name'),
                selected_available_country: multiSelectLabel(previousFormData?.Selected_available_coutries, 'id', 'country_name'),
                age_restrict: assignDefault(previousFormData.age_restrict),
                search_tags: previousFormData?.search_tags?.split(",")?.map((tag) => tag?.trim()),
                rtmp_type: result?.rtmpOption?.map(item => ({ name: item?.name, value: item?.value })),
                stream_id: result?.Livestream_source
                    ?.filter((item) => item?.value === "Encode_stream_video")
                    ?.flatMap((item) => item?.Rtmp_urls || [])
                    ?.find((rtmpItem) =>
                        rtmpItem?.rtmp_url?.split("/")?.pop() === previousFormData?.Stream_key
                            ? rtmpItem?.rtmp_url?.split("/")?.pop()
                            : ''
                    ),
                // Handle schedule programs - load from API response
                schedule_programs: result?.schedule_programs && result.schedule_programs.length > 0 ?
                    result.schedule_programs :
                    [{
                        id: Date.now(),
                        name: "",
                        description: "",
                        start_time: "",
                        end_time: "",
                        days: "",
                        selectedDays: [],
                        image: ""
                    }]
            }
            setFormData(updatedFormData);
            setPageFor(response?.data?.page_for);

            // Default DropDown List

            const defaultoptionslist = {
                artistsOption: multiSelectLabel(result.artists, 'id', 'artist_name'),
                categoryOption: result.radio_station_category || [],
                languageOption: multiSelectLabel(result.livestream_language, 'id', 'name'),
                blockCountryOption: multiSelectLabel(result.Country, 'id', 'name'),
                availableCountryOption: multiSelectLabel(result.Country, 'id', 'name'),
                ageOption: result?.Age || [],
                accessOption: (result?.user_access && result?.user_access.length > 0) ? result.user_access : [
                    { value: 'guest', name: 'Guest (everyone)' },
                    { value: 'registered', name: 'Registered Users( Must register to watch )' },
                    { value: 'subscriber', name: 'Subscriber ( Must subscribe to watch )' },
                    { value: 'ppv', name: 'PPV Users (Pay per movie)' }
                ],
                liveSourceOption: result?.Livestream_source || [],
                rtmpOption: (result?.Livestream_source || [])
                    .filter((item) => item.value === "Encode_stream_video")
                    .flatMap((item) => item.Rtmp_urls || [])
                    .map((rtmpItem) => ({ name: `Streaming Video ${rtmpItem?.id}`, value: rtmpItem?.id, rtmp_url: rtmpItem?.rtmp_url, hls_url: rtmpItem?.hls_url })),
                globalOption: result?.ppv_gobal_price ? result?.ppv_gobal_price : 0,
                iosOption: result?.InappPurchases || [],
                defaultCurrency: result?.DefaultCurrency,
            }
            setDefaultOption(defaultoptionslist);
            setConvertPrice(prevState => {
                return {
                    ...prevState,
                    PPVType: formData?.global_ppv,
                    PriceType: result?.DefaultCurrency?.code,
                    ActualPrice: formData?.ppv_price,
                    IOSPrice: formData?.ios_ppv_price,
                    convertedPriceRates: [...(result?.ContentPriceRates || [])]
                };
            });
            setLoading(false)
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const fetchCreate = async () => {
        try {
            const response = await axios.get(`${createApi}`, { headers: headers });
            const result = response?.data?.data;
            // if (result) {
            //   toast.success(response?.data?.message)
            // }

            // Default DropDown List

            const defaultoptionslist = {
                artistsOption: multiSelectLabel(result?.artists, 'id', 'artist_name'),
                categoryOption: result?.radio_station_category || [],
                languageOption: multiSelectLabel(result?.livestream_language, 'id', 'name'),
                blockCountryOption: multiSelectLabel(result?.Country, 'id', 'name'),
                availableCountryOption: multiSelectLabel(result?.Country, 'id', 'name'),
                liveSourceOption: result?.Livestream_source || [],
                rtmpOption: (result?.Livestream_source || [])
                    .filter((item) => item.value === "Encode_stream_video")
                    .flatMap((item) => item.Rtmp_urls)
                    .map((rtmpItem) => ({ name: `Streaming Video ${rtmpItem?.id}`, value: rtmpItem?.id, rtmp_url: rtmpItem?.rtmp_url, hls_url: rtmpItem?.hls_url })),
                ageOption: result?.Age,
                accessOption: (result?.user_access && result?.user_access.length > 0) ? result.user_access : [
                    { value: 'guest', name: 'Guest (everyone)' },
                    { value: 'registered', name: 'Registered Users( Must register to watch )' },
                    { value: 'subscriber', name: 'Subscriber ( Must subscribe to watch )' },
                    { value: 'ppv', name: 'PPV Users (Pay per movie)' }
                ],
                iosOption: result?.InappPurchases || [],
                defaultCurrency: result?.DefaultCurrency,
                globalOption: result?.ppv_gobal_price ? result?.ppv_gobal_price : 0,
            }
            setFormData(prev => ({
                ...prev,
                rtmp_type: result?.rtmpOption?.map(item => ({ name: item?.name, value: item?.value })),
            }))
            setDefaultOption(defaultoptionslist);
            setGetGeoFencing(result?.getGeofencing);
            setGetGeoFencingAvailableCountries(result?.getGeofencingAvailableCountries);
            setPageFor(response?.data?.page_for);
            setLoading(false)
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const assignDefault = (value, defaultValue = 0) => value ? value : defaultValue;

    const closeModal = () => {
        setModelClose(!closeModal);
        setShowModal(false);
    };

    const labelFetch = async () => {
        try {
            setShowOverlay(true)
            const response = await axios.get(`${labelApi}`, { headers: headers });
            const result = response?.data?.label_management
            setLabelDisplay(result)
            setShowOverlay(false)
        }
        catch (err) {
            setShowOverlay(false)
            toast.error(err.response.data.message)

        }
    }

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;


        if (name === "free_duration_time" || name === "duration") {
            const digitsOnly = value.replace(/\D/g, "");

            if (digitsOnly.length <= 6) {
                let formattedTime = digitsOnly;
                if (digitsOnly.length === 6) {
                    const hours = parseInt(digitsOnly.slice(0, 2));
                    const minutes = parseInt(digitsOnly.slice(2, 4));
                    const seconds = parseInt(digitsOnly.slice(4, 6));

                    if (hours <= 23 && minutes <= 59 && seconds <= 59) {
                        formattedTime = `${digitsOnly.slice(0, 2)}:${digitsOnly.slice(2, 4)}:${digitsOnly.slice(4, 6)}`;
                    } else {
                        setFormDataError((prev) => ({
                            ...prev,
                            [name]: "Please enter a valid time (HH:MM:SS format, hours: 00-23, minutes/seconds: 00-59)",
                        }));
                        return;
                    }
                }

                setFormData((prev) => ({
                    ...prev,
                    [name]: formattedTime,
                }));

                setFormDataError((prev) => ({
                    ...prev,
                    [name]: '',
                }));
            }
            return;
        }

        if (type === "radio") {
            if (name == "publish_now" || name == "publish_later") {
                setFormData((prev) => ({
                    ...prev,
                    publish_type: checked ? name : ''
                }));
            }
            if (name == "global_ppv") {
                setFormData((prev) => ({
                    ...prev,
                    [name]: value
                }));
            }
        }

        if (type === "checkbox") {
            setFormData((prev) => ({
                ...prev,
                [name]: checked ? 1 : 0,
            }));
            if (name == "free_duration_status") {
                if (!checked) {
                    setFormDataError((prev) => ({
                        ...prev,
                        ['free_duration_time']: '',
                    }));
                }
            }
            if (name == "enable_Tips") {
                if (!checked) {
                    setFormDataError((prev) => ({
                        ...prev,
                        ['donations_label']: '',
                    }));
                }

            }
            if (name == "global_ppv") {
                if (checked) {
                    setFormData((prev) => ({
                        ...prev,
                        ['ppv_price']: defaultOption?.globalOption,
                    }));
                }
                else {
                    setFormData((prev) => ({
                        ...prev,
                        ['ppv_price']: '',
                    }));
                }

            }
        }

        if (type === 'text') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === 'select-one') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === "datetime-local") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

        if (type === "textarea") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
        if (type === "number") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

    };

    const handleTagsChange = (newTags) => {
        const cleanedTags = (newTags || [])
            .flatMap((tag) => String(tag ?? "").split(","))
            .map((tag) => tag?.trim().toLowerCase())
            .filter((tag) => tag !== "")
            .filter((value, index, self) => self.indexOf(value) === index);
        setFormData((prevFormData) => ({
            ...prevFormData,
            search_tags: cleanedTags,
        }));
    };

    const handleBlurtitle = () => {
        if (!formData?.slug) {
            generateSlug(formData?.title);
        }
    };

    const generateSlug = async (title) => {
        const slug = await slugGenerator(title)
        setFormData((prev) => ({
            ...prev,
            'slug': slug,
        }));
    };

    const handleInputKeyDowntitle = (event) => {
        if (!formData?.slug) {
            if (event.key === "Enter" || event.key === "Tab") {
                generateSlug(formData?.title);
            }
        }
    };

    const handleMultiSelect = (selectedOptions, actionMeta) => {
        setFormData((prev) => ({
            ...prev,
            [actionMeta.name]: selectedOptions
        }))
        setFormDataError((prev) => ({
            ...prev,
            [actionMeta.name]: ""
        }))
    }

    const formValidation = () => {
        let formIsValid = true;
        if (!formData?.title || formData.title?.trim() === '') {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                title: "Title cannot be empty or contain only spaces.",
            }));
            if (combinedRef.current['title']) {
                combinedRef.current['title'].focus()
            }
            formIsValid = false;
        }
        if (!formData?.slug || formData.slug?.trim() === '') {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                slug: "Slug cannot be empty or contain only spaces.",
            }));
            if (combinedRef.current['slug']) {
                combinedRef.current['slug'].focus()
            }
            formIsValid = false;
        }
        // if (!formData?.age_restrict) {
        //     setFormDataError((prevFormData) => ({
        //         ...prevFormData,
        //         age_restrict: "Age cannot be empty.",
        //     }));
        //     if (combinedRef.current['age_restrict']) {
        //         combinedRef.current['age_restrict'].focus()
        //     }
        //     formIsValid = false;
        // }
        if (!formData?.access) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                access: "Choose the access.",
            }));
            if (combinedRef.current['access']) {
                combinedRef.current['access'].focus()
            }
            formIsValid = false;
        }
        if (!formData?.url_type) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                url_type: "choose url or file.",
            }));
            if (combinedRef.current['url_type']) {
                combinedRef.current['url_type'].focus()
            }
            formIsValid = false;
        }

        if (formData?.website_URL) {
            const urlPattern = /^https?:\/\/(?:[-\w.])+(?::[0-9]+)?(?:\/[^?\s]*)?(?:\?[^#\s]*)?(?:#[^\s]*)?$/i;
            if (!urlPattern.test(formData.website_URL)) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    website_URL: "Please enter a valid URL format starting with http:// or https://",
                }));
                if (combinedRef.current['website_URL']) {
                    combinedRef.current['website_URL'].focus()
                }
                formIsValid = false;
            }
        }

        if (!id && (formData?.url_type === "mp3_audio_upload" || formData?.url_type === "aac_audio_upload") && checkFileUpload === false && selectedIds?.length <= 0) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                url_type: "Please select an audio file to upload.",
            }));
            if (combinedRef.current['url_type']) {
                combinedRef.current['url_type'].focus()
            }
            formIsValid = false;
        }

        if (formData?.url_type === "mp3_url" && (!formData?.m3u_url || formData?.m3u_url?.trim() !== formData?.m3u_url)) {
            const urlPattern = /^https?:\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/;
            if (!urlPattern.test(formData?.m3u_url?.trim())) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    m3u_url: "Please provide a valid MP3 stream URL",
                }));
                if (combinedRef.current['m3u_url']) {
                    combinedRef.current['m3u_url'].focus();
                }
                formIsValid = false;
            }
        }

        if (formData?.url_type === "aac_url" && (!formData?.acc_audio_url || formData.acc_audio_url?.trim() !== formData.acc_audio_url)) {
            const urlPattern = /^https?:\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/;
            if (!urlPattern.test(formData.acc_audio_url?.trim())) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    acc_audio_url: "Please provide a valid AAC stream URL",
                }));
                if (combinedRef.current['acc_audio_url']) {
                    combinedRef.current['acc_audio_url'].focus();
                }
                formIsValid = false;
            }
        }

        if (formData?.url_type === "embed_url") {
            if (!formData?.embed_url?.trim()) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    embed_url: "Embed URL cannot be empty.",
                }));
                if (combinedRef.current['embed_url']) {
                    combinedRef.current['embed_url'].focus();
                }
                formIsValid = false;
                return;
            }

            const embedCode = formData.embed_url?.trim();
            const urlPattern = /^https?:\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/;

            if (!urlPattern.test(embedCode)) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    embed_url: "Please provide a valid radio player embed URL starting with http:// or https://",
                }));
                if (combinedRef.current['embed_url']) {
                    combinedRef.current['embed_url'].focus();
                }
                formIsValid = false;
                return;
            }
        }

        if (formDataError?.image) {
            if (combinedRef.current['image']) {
                combinedRef.current['image'].focus()
            }
            formIsValid = false;
        }
        if (formDataError?.player) {
            if (combinedRef.current['player']) {
                combinedRef.current['player'].focus()
            }
            formIsValid = false;
        }
        if (formDataError?.tv) {
            if (combinedRef.current['tv']) {
                combinedRef.current['tv'].focus()
            }
            formIsValid = false;
        }
        if (formDataError?.player_cover) {
            if (combinedRef.current['player_cover']) {
                combinedRef.current['player_cover'].focus()
            }
            formIsValid = false;
        }
        if (formData?.free_duration_status) {
            const rawDuration = formData?.free_duration_time?.replace(/\D/g, '');
            if (!formData?.free_duration_time || rawDuration.length !== 6) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    free_duration_time: "Free Duration must be exactly 6 digits in HH:MM:SS format.",
                }));
                if (combinedRef.current['free_duration_time']) {
                    combinedRef.current['free_duration_time'].focus();
                }
                formIsValid = false;
            } else {
                const [hh, mm, ss] = [
                    rawDuration.slice(0, 2),
                    rawDuration.slice(2, 4),
                    rawDuration.slice(4, 6)
                ];

                const hours = parseInt(hh, 10);
                const minutes = parseInt(mm, 10);
                const seconds = parseInt(ss, 10);

                const isValidTime =
                    hours >= 0 && hours <= 23 &&
                    minutes >= 0 && minutes <= 59 &&
                    seconds >= 0 && seconds <= 59;

                if (!isValidTime || (hours === 0 && minutes === 0 && seconds === 0)) {
                    setFormDataError((prevFormData) => ({
                        ...prevFormData,
                        free_duration_time: "Free Duration must be a valid time (not 00:00:00).",
                    }));
                    if (combinedRef.current['free_duration_time']) {
                        combinedRef.current['free_duration_time'].focus();
                    }
                    formIsValid = false;
                }
            }
        }

        if (formData?.duration) {
            const rawDuration = formData.duration.replace(/\D/g, '');
            if (rawDuration.length !== 6) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    duration: "Duration must be exactly 6 digits in HH:MM:SS format.",
                }));
                if (combinedRef.current['duration']) {
                    combinedRef.current['duration'].focus();
                }
                formIsValid = false;
            } else {
                const hours = parseInt(rawDuration.slice(0, 2), 10);
                const minutes = parseInt(rawDuration.slice(2, 4), 10);
                const seconds = parseInt(rawDuration.slice(4, 6), 10);

                if (
                    hours > 23 || minutes > 59 || seconds > 59 ||
                    (hours === 0 && minutes === 0 && seconds === 0)
                ) {
                    setFormDataError((prevFormData) => ({
                        ...prevFormData,
                        duration: "Please enter a valid time between 00:00:01 and 23:59:59",
                    }));
                    if (combinedRef.current['duration']) {
                        combinedRef.current['duration'].focus();
                    }
                    formIsValid = false;
                }
            }
        }

        if (formData?.enable_Tips) {
            if (!formData?.donations_label) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    donations_label: "Donate price cannot be empty.",
                }));
                if (combinedRef.current['donations_label']) {
                    combinedRef.current['donations_label'].focus()
                }
                formIsValid = false;
            }
        }

        if (formData?.url_type == "mp3_url") {
            if (!formData?.m3u_url) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    m3u_url: "MP3 URL cannot be empty",
                }));
                if (combinedRef.current['m3u_url']) {
                    combinedRef.current['m3u_url'].focus()
                }
                formIsValid = false;
            }
        }
        if (formData?.url_type == "acc_audio_url") {
            if (!formData?.acc_audio_url) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    acc_audio_url: "AAC URL cannot be empty",
                }));
                if (combinedRef.current['acc_audio_url']) {
                    combinedRef.current['acc_audio_url'].focus()
                }
                formIsValid = false;
            }
        }
        if (formData?.url_type == "embed_url") {
            if (!formData?.embed_url) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    embed_url: "Embed URL cannot be empty",
                }));
                if (combinedRef.current['embed_url']) {
                    combinedRef.current['embed_url'].focus()
                }
                formIsValid = false;
            }
        }
        // Audio file upload validation
        if ((formData?.url_type == "mp3_audio_upload" || formData?.url_type == "aac_audio_upload") && !selectedIds?.length && !checkFileUpload) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                url_type: "Please select an audio file to upload",
            }));
            if (combinedRef.current['url_type']) {
                combinedRef.current['url_type'].focus()
            }
            formIsValid = false;
        }
        if (formData?.publish_type == "publish_now") {
            if (!formData?.year) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    year: "Year cannot be empty.",
                }));
                if (combinedRef.current['year']) {
                    combinedRef.current['year'].focus()
                }
                formIsValid = false;
            }
        }
        if (formData?.publish_type == "publish_later") {
            if (!formData?.publish_time) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    publish_time: "Publish time cannot be empty.",
                }));
                if (combinedRef.current['publish_time']) {
                    combinedRef.current['publish_time'].focus()
                }
                formIsValid = false;
            }
        }

        // Schedule Program Validation
        if (!formData?.schedule_programs || formData?.schedule_programs.length === 0) {
            toast.error("At least one scheduled program is required.");
            formIsValid = false;
        } else {
            formData.schedule_programs.forEach((program, index) => {
                // Program name validation
                if (!program.name || program.name?.trim() === '') {
                    setFormDataError((prevFormData) => ({
                        ...prevFormData,
                        [`schedule_program_${program.id}_name`]: "Program name is required.",
                    }));
                    formIsValid = false;
                }

                // Program description validation
                if (!program.description || program.description?.trim() === '') {
                    setFormDataError((prevFormData) => ({
                        ...prevFormData,
                        [`schedule_program_${program.id}_description`]: "Program description is required.",
                    }));
                    formIsValid = false;
                }

                if (!program.selectedDays || !Array.isArray(program.selectedDays) || program.selectedDays.length === 0) {
                    setFormDataError((prevFormData) => ({
                        ...prevFormData,
                        [`schedule_program_${program.id}_days`]: "At least one program day is required.",
                    }));
                    formIsValid = false;
                }

                // Start time validation
                if (!program.start_time || program.start_time?.trim() === '') {
                    setFormDataError((prevFormData) => ({
                        ...prevFormData,
                        [`schedule_program_${program.id}_start_time`]: "Start time is required.",
                    }));
                    formIsValid = false;
                }

                // End time validation
                if (!program.end_time || program.end_time?.trim() === '') {
                    setFormDataError((prevFormData) => ({
                        ...prevFormData,
                        [`schedule_program_${program.id}_end_time`]: "End time is required.",
                    }));
                    formIsValid = false;
                }

                // Time logic validation (end time should be after start time)
                if (program.start_time && program.end_time) {
                    const startTime = new Date(`1970-01-01T${program.start_time}:00`);
                    const endTime = new Date(`1970-01-01T${program.end_time}:00`);
                    if (endTime <= startTime) {
                        setFormDataError((prevFormData) => ({
                            ...prevFormData,
                            [`schedule_program_${program.id}_end_time`]: "End time must be after start time.",
                        }));
                        formIsValid = false;
                    }
                }

                // Check for image validation errors
                if (formDataError?.[`schedule_program_${program.id}_image`]) {
                    formIsValid = false;
                }
            });
        }

        if (!formData?.title || formData?.title?.trim().length < 3 || formData?.title?.trim().length > 100) {
            toast.error("Title must be between 3 and 100 characters.");
            formIsValid = false;
        }

        if (!formData?.slug || formData?.slug?.trim().length < 3 || formData?.slug?.trim().length > 100) {
            toast.error("Slug must be between 3 and 100 characters.");
            formIsValid = false;
        }

        return formIsValid;
    }

    const handleFileUpload = async (id, name) => {
        try {
            const formDataAdd = new FormData();
            if (name === 'video-image') {
                console.log("formDataAdd", formDataAdd);
                const imageFields = []; // Initialize imageFields array

                formDataAdd.append('id', id);

                if (coverImageFile) {
                    formDataAdd.append('image', coverImageFile);
                    imageFields.push('image');
                }
                if (playerImageFile) {
                    formDataAdd.append('player_image', playerImageFile);
                    imageFields.push('player_image');
                }
                if (tvImageFile) {
                    formDataAdd.append('Tv_live_image', tvImageFile);
                    imageFields.push('Tv_live_image');
                }
                if (playerCoverImageFile) {
                    formDataAdd.append('radio_station_player_cover', playerCoverImageFile);
                    imageFields.push('radio_station_player_cover');
                }

                formDataAdd.append('modelName', 'LiveStream');

                imageFields.forEach((field) => {
                    formDataAdd.append('imageFields[]', field);
                });

                const response = await fetchRequest({ method: 'POST', url: imageApi, data: formDataAdd });
                if (response?.data?.status) {
                    // toast.success(response?.data?.message)
                }
            }
            if (name == 'live_video') {
                formDataAdd.append('livestream_video', liveVideo)
                const response = await axios.patch(`${liveUploadFile}/${id}`, formDataAdd, { headers: headers });
            }
            setCoverImageFile(null)
            setPlayerImageFile(null)
            setTvImageFile(null)
            setPlayerCoverImageFile(null)
            setLiveVideo(null)

        } catch (err) {
            toast.error(err?.response?.data?.message)
        }
    }

    const handleAdd = async (live_id) => {
        const findApi = !id && !live_id && !uploadLiveId ? addApi : `${updateApi}/${id ? id : live_id ? live_id : uploadLiveId}`
        const method = !id && !live_id && !uploadLiveId ? 'POST' : 'PATCH';
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["title", "slug", "details", "description", "duration", "year", "rating", "age_restrict", "Meta_description", "website_page_title", "website_URL", "url_type", "acc_audio_url", "embed_url", "access", "free_duration_status", "free_duration_time", "featured", "active", "banner", "enable_chats", "record_enable", "enable_Tips", "donations_label", "publish_time", "global_ppv", "ppv_price", "ios_ppv_price"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            if (formData?.url_type === "mp3_url" && formData?.m3u_url) {
                formDataAdd['mp3_url'] = formData.m3u_url; // Backend expects mp3_url but frontend uses m3u_url
            }

            if (formData?.url_type === "aac_audio_upload" && (selectedIds?.length || uploadLiveId)) {
                formDataAdd['acc_audio_file'] = selectedIds?.[0] || uploadLiveId;
            }
            if (formData?.url_type === "mp3_audio_upload" && (selectedIds?.length || uploadLiveId)) {
                formDataAdd['mp3_audio_file'] = selectedIds?.[0] || uploadLiveId;
            }
            formDataAdd['artists_id'] = Array.isArray(formData?.selected_artists) ? formData.selected_artists.map((option) => option?.value).join() : ''
            formDataAdd['category_id'] = Array.isArray(formData?.selected_categories) ? formData.selected_categories.join(',') : ''
            formDataAdd['language_id'] = Array.isArray(formData?.selected_Languages) ? formData.selected_Languages.map((option) => option?.value).join() : ''
            formDataAdd['block_countries_id'] = Array.isArray(formData?.selected_blocked_country) ? formData.selected_blocked_country.map((option) => option?.value).join() : ''
            formDataAdd['available_countries_id'] = Array.isArray(formData?.selected_available_country) ? formData.selected_available_country.map((option) => option?.value).join() : ''
            formDataAdd['search_tags'] = Array.isArray(formData?.search_tags) ? formData.search_tags.join(",") : ''
            formDataAdd['publish_status'] = formData?.publish_type == "publish_now" ? 1 : 0;
            formDataAdd['publish_type'] = formData?.publish_type;

            const schedulePrograms = formData?.schedule_programs?.map(program => ({
                name: program.name,
                description: program.description,
                start_time: program.start_time,
                end_time: program.end_time,
                days: program.selectedDays ? program.selectedDays.map(day => day.value) : [],
                image_url: program.image || null,
                sort_order: 0
            })) || [];

            formDataAdd['schedule_programs'] = JSON.stringify(schedulePrograms);

            const response = await axios({ method: method, url: findApi, data: formDataAdd, headers: headers, });
            const result = response?.data;
            if (result?.status) {
                // save custom field values (conditional)
                try {
                    const entityId = result?.id || id;
                    const { saveCustomFieldsConditional } = await import('../../../CustomFields/conditionalCustomFieldsWrapper');
                    const cfRes = await saveCustomFieldsConditional(
                        baseURL,
                        headers,
                        'radio-station',
                        entityId,
                        customFieldValues
                    );
                    if (!cfRes?.data?.status) throw new Error(cfRes?.data?.message || 'Failed to save additional fields');
                } catch (e) {
                    toast.error(e?.response?.data?.message || e.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                if (coverImageFile || playerImageFile || tvImageFile || playerCoverImageFile) {
                    await handleFileUpload(result?.id, 'video-image')
                }

                // Upload schedule program images if any
                if (Object.keys(scheduleImageFiles).length > 0) {
                    await handleScheduleProgramImageUploads(result?.id);
                }

                if (result?.id) {
                    await handlePPVPriceStore(result?.id || id)
                }
                setShowOverlay(false);
                setGalleryModal(false)
                toast.success(result?.message)
                if (!id) {
                    navigate("/radio-station");
                }
                else {
                    setWithOutRefresh(!withOutRefresh)
                }
            }
            else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }
    }

    const handleStore = async (e) => {
        e.preventDefault()
        if (formValidation()) {
            if (selectedIds?.length) {
                let response_id;
                if (!moveVideo) {
                    response_id = await handleMoveAudio(selectedIds);
                }
                return handleAdd(response_id)
            }
            let findLibrary = await uploadingFiles.filter((item) => item?.from == "radio")
            if (findLibrary?.length) {
                return handleAdd(findLibrary[findLibrary?.length - 1]?.id)
            }
            return handleAdd()

        }
    }

    const handlePriceModal = () => {
        setPriceModel((prev) => !prev)
    }

    const handlePriceModalClose = async () => {
        setFormData((prev) => ({
            ...prev,
            ppv_price: formData?.ppv_price,
            ios_ppv_price: formData?.ios_ppv_price,
            global_ppv: formData?.global_ppv
        }))
        await handlePriceModal()
        // await handleCovertPrice(editData?.ppv_price)
    }

    const handleCovertPrice = async (value) => {
        let formIsValid = true
        if (!formData?.ppv_price) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                ppv_price: "ppv price cannot be empty.",
            }));
            if (combinedRef.current['ppv_price']) {
                combinedRef.current['ppv_price'].focus()
            }
            formIsValid = false;
        }
        if (formIsValid) {
            const selectedCountryCode = defaultOption?.defaultCurrency?.code
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_Curreny_generate}/${selectedCountryCode}`);
                const rates = response.data.rates;
                const convertedPrices = allCurrencylistfromappi?.map(item => {
                    let country_name = item?.country;
                    let Symbol = item?.Symbol || item?.symbol;
                    let Code = item?.code;

                    const matchingCountry = allCurrencylistfromappi.find(currency => currency.code === item?.code);
                    if (matchingCountry) {
                        country_name = matchingCountry?.country;
                        Symbol = matchingCountry?.Symbol || matchingCountry?.symbol;
                    }

                    return {
                        Code: Code,
                        Country: country_name,
                        Symbol: Symbol,
                        ConvertedPriceRate: (value * (rates[item?.code] || 0)).toFixed(2),
                        price: value,
                        RateDifference: ((value * (rates[item?.code] || 0)) - value).toFixed(2),
                        editPrice: (value * (rates[item?.code] || 0)).toFixed(2),
                        ChangedPrice: (value * (rates[item?.code] || 0)).toFixed(2),
                        isEditable: true,
                    };
                });

                setConvertPrice(prevState => ({
                    ...prevState,
                    source_type: 2,
                    PPVType: formData?.global_ppv,
                    PriceType: selectedCountryCode,
                    ActualPrice: value,
                    IOSPrice: formData?.ios_ppv_price,
                    convertedPriceRates: convertedPrices
                }));
            } catch (error) {
                console.error('Error fetching currency conversion rates:', error);
            }
        }
    };

    const handlePPVPriceStore = async (sourceID) => {
        setShowOverlay(true);
        try {
            const response = await axios.post(`${updatePPV}`, { ...convertPrice, source_id: sourceID }, { headers: headers });
            const result = response?.data
            if (result?.status) {
                setShowOverlay(false);
                setPriceModel(false)
                // toast.success(result?.message)
            }
            else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
    }


    const handlePriceChangeInput = (e, index) => {
        const { value } = e.target;
        setConvertPrice(prevState => {
            const updatedRates = [...prevState.convertedPriceRates];
            updatedRates[index] = {
                ...updatedRates[index],
                ConvertedPriceRate: value
            };
            return {
                ...prevState,
                convertedPriceRates: updatedRates
            };
        });
    };


    const handleToggleGalleryModel = (val) => {
        setGalleryModal(prev => !prev)
        if (val == "clear") {
            setSelectedIds([])
        }

    }

    const handleCheckboxChange = (id) => {
        if (id) {
            setSelectedIds((prevSelectedIds) => {
                if (prevSelectedIds?.includes(id)) {
                    return [];
                } else {
                    return [id];
                }
            });
        }
    };


    const handleMoveAudio = async (library_id) => {
        try {
            const formDataAdd = {};
            let response
            if (!id) {
                formDataAdd['video_ids'] = [library_id]
                response = await axios.post(`${moveApi}`, formDataAdd, { headers: headers });
                setMoveVideo(true);
            }
            else {
                response = await axios.post(`${assignApi}/?radio_id=${id}&library_id=${library_id}&updated_type=audio`, {}, { headers: headers });
            }

            const result = response?.data;
            if (result?.status) {
                toast.success(result?.message);
                setSelectedIds(result?.data)
                handleToggleGalleryModel();
                setUploadLiveId(result?.ids?.[0]);
                return result?.ids?.[0] || result?.id
            }
            else {
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }

    }

    const handleLibraryChange = async (e, name) => {
        const files = e.target.files;
        if (!files?.length) return;

        const allowedTypes = /audio\/(mp3|mpeg|aac|x-aac|mp4|m4a)/;
        const allowedExtensions = ['.mp3', '.aac', '.m4a'];

        for (let file of files) {

            const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
            const isAllowedExtension = allowedExtensions.includes(fileExtension);
            const isAllowedMimeType = allowedTypes.test(file.type);

            if (!isAllowedMimeType && !isAllowedExtension) {
                toast.error(`Unsupported audio file format: ${file.name}. Please upload MP3 or AAC files.`);
                e.target.value = '';
                return;
            }
        }
        setCheckFileUpload(true);
        const response = await handleFileChangeProvider(e, `${uploadFileApi}${id ? `&action_type=updated&video_id=${id}` : '&action_type=created'}`, "radio")
        setUploadLiveId(response[0]?.id);
        console.log("uploadRadioId", response);
    }

    // Schedule Program Handlers
    const handleAddScheduleProgram = () => {
        const newProgram = {
            id: Date.now(),
            name: "",
            description: "",
            start_time: "",
            end_time: "",
            days: "",
            selectedDays: [],
            image: ""
        };
        setFormData(prev => ({
            ...prev,
            schedule_programs: [...prev.schedule_programs, newProgram]
        }));
    };

    const handleRemoveScheduleProgram = (programId) => {
        setFormData(prev => ({
            ...prev,
            schedule_programs: prev.schedule_programs.filter(program => program.id !== programId)
        }));
        // Remove associated image file
        setScheduleImageFiles(prev => {
            const newFiles = { ...prev };
            delete newFiles[programId];
            return newFiles;
        });
        // Clear validation errors for removed program
        setFormDataError(prev => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach(key => {
                if (key.startsWith(`schedule_program_${programId}_`)) {
                    delete newErrors[key];
                }
            });
            return newErrors;
        });
    };

    const handleScheduleProgramChange = (programId, field, value) => {
        setFormData(prev => ({
            ...prev,
            schedule_programs: prev.schedule_programs.map(program =>
                program.id === programId ? { ...program, [field]: value } : program
            )
        }));
        // Clear validation error for this field
        setFormDataError(prev => ({
            ...prev,
            [`schedule_program_${programId}_${field}`]: ""
        }));
    };

    // validateImageRatio is already available from useMyContext

    const handleScheduleImageChange = async (event, programId) => {
        console.log('handleScheduleImageChange called:', { programId, filesLength: event.target.files?.length });
        const { files, name } = event.target;
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

        if (files?.length > 0) {
            const newFile = files[0];
            console.log('Processing new file:', { programId, fileName: newFile.name, fileType: newFile.type });

            // Image type validation
            if (!allowedTypes.includes(newFile.type)) {
                console.log('File type validation failed:', newFile.type);
                setFormDataError(prev => ({
                    ...prev,
                    [`schedule_program_${programId}_image`]: "Only JPG, JPEG, WEBP and PNG files are allowed."
                }));
                return;
            }

            // Image ratio validation (optional - temporarily disabled to allow any image)
            // const isValidSize = await validateImageRatio(newFile, 16 / 9, 1280, 720);
            // if (!isValidSize) {
            //     console.log('Image size validation failed:', { fileName: newFile.name });
            //     setFormDataError(prev => ({
            //         ...prev,
            //         [`schedule_program_${programId}_image`]: "Image must be in 16:9 Ratio or 1280x720px."
            //     }));
            //     return;
            // }

            console.log('Storing image file for program:', { programId, fileName: newFile.name });
            // Store the file
            setScheduleImageFiles(prev => {
                const updatedFiles = {
                    ...prev,
                    [programId]: newFile
                };
                console.log('Updated scheduleImageFiles:', Object.keys(updatedFiles));
                return updatedFiles;
            });

            // Clear any previous errors
            setFormDataError(prev => ({
                ...prev,
                [`schedule_program_${programId}_image`]: ""
            }));
        }
    };

    const handleClearScheduleImage = (programId) => {
        setScheduleImageFiles(prev => {
            const newFiles = { ...prev };
            delete newFiles[programId];
            return newFiles;
        });
        handleScheduleProgramChange(programId, 'image', '');
        setFormDataError(prev => ({
            ...prev,
            [`schedule_program_${programId}_image`]: ""
        }));
    };

    const handleScheduleProgramImageUploads = async (livestreamId) => {
        try {

            await new Promise(resolve => setTimeout(resolve, 1000));

            const response = await axios.get(`${editApi}/${livestreamId}`, { headers: headers });
            const savedPrograms = response?.data?.data?.schedule_programs || [];

            for (const [frontendProgramId, imageFile] of Object.entries(scheduleImageFiles)) {
                if (imageFile) {

                    const programIndex = formData.schedule_programs.findIndex(p => p.id == frontendProgramId);
                    const savedProgram = savedPrograms[programIndex];

                    if (savedProgram && savedProgram.id) {

                        const formDataAdd = new FormData();
                        formDataAdd.append('id', savedProgram.id);
                        formDataAdd.append('image', imageFile);
                        formDataAdd.append('modelName', 'RadioStation');
                        formDataAdd.append('imageFields[]', 'image');

                        const uploadResponse = await fetchRequest({ method: 'POST', url: imageApi, data: formDataAdd });

                        if (uploadResponse?.data?.status) {

                            const imageFilename = uploadResponse?.data?.updatedFields?.image;
                            const imageUrl = uploadResponse?.data?.data?.image;

                            if (imageFilename) {
                                handleScheduleProgramChange(frontendProgramId, 'image', imageFilename);
                            }
                        } else {
                            toast.error(`Failed to upload image for program: ${savedProgram.name || 'Unknown'}`);
                        }
                    } else {
                        console.warn(`Could not find saved program for frontend ID: ${frontendProgramId}`);
                        console.warn('Available saved programs:', savedPrograms.map(p => ({ id: p.id, name: p.name })));
                    }
                }
            }

            setScheduleImageFiles({});

        } catch (err) {
            toast.error(err?.response?.data?.message || 'Error uploading schedule program images');
        }
    };


    useEffect(() => {
        const initFetch = async () => {
            if (id) {
                await fetchData();
            } else {
                await fetchCreate();
            }
            labelFetch();
        };
        initFetch();
    }, [withOutRefresh]);




    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }


    const confirmToggle = (suggestedText) => {
        if (suggestedText && typeof suggestedText === 'string' && modalTarget) {
            setFormData(prev => ({ ...prev, [modalTarget]: suggestedText }));
        }
        setShowModal(false);
        setModalTarget(null);
    };

    const handleModal = (target) => {
        setModalTarget(target);
        if (target === "description") {
            setDefaultPrompt(`Give a short description about "${formData?.title || ""}"`);
        } else if (target === "details") {
            setDefaultPrompt(`Expand the content details for "${formData?.title || ""}"`);
        }
        setShowModal(true);
    };

    const generateSuggestion = async (promptText, setSuggestion, setLoading) => {
        const trimmedPrompt = promptText?.trim();
        setLoading(true);
        try {
            const response = await axios.post(
                generateAISuggestionApi,
                { prompt: trimmedPrompt },
                { headers }
            );
            if (response.data?.status) {
                setLoading(false);
                setSuggestion(response.data.response);
            } else {
                alert(response.data.message || "Failed to generate suggestion.");
            }
        } catch (error) {
            if (error.response?.status === 401) {
                alert("Token expired or invalid. Please login again.");
            } else {
                console.error(error);
                alert("Error generating suggestion.");
            }
        }
    };

    if (showOverlay) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }

    return (
        <div className="pb-5">
            {/* {showOverlay && (<Response_Processing></Response_Processing>)} */}
            {galleryModal && <AdminGalleryModal modelClose={galleryModal} closeAction={handleToggleGalleryModel} sourceType={5} saveAction={handleMoveAudio} changeAction={handleCheckboxChange} selectedIds={selectedIds} buttonText={"Select Audio"} />}
            {categoryModal && (
                <div className={`modal packageModel fade ${categoryModal && 'd-block show'}`} id="radioStationCategoryModal" tabIndex="-1" role="dialog" aria-labelledby="radioStationCategoryModalLabel">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content theme-bg-color">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Add Radio Station Category" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={() => setCategoryModal(false)} aria-label="Close">
                                    <IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} />
                                </button>
                            </div>
                            <div className="modal-body">
                                <RadioStationCategoryAddEdit isModal={true} forceCreate={true} onSuccess={(newId, newName) => {
                                    if (newId && newName) {
                                        setDefaultOption(prev => ({
                                            ...prev,
                                            categoryOption: [...(prev?.categoryOption || []), { id: newId, name: newName, sub_category: [] }]
                                        }));
                                        setFormData(prev => {
                                            const curr = Array.isArray(prev?.selected_categories) ? prev.selected_categories : [];
                                            return { ...prev, selected_categories: [...curr, newId] };
                                        });
                                    }
                                    setCategoryModal(false);
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {pricemodel &&
                <div class={`modal  packageModel fade ${pricemodel && 'd-block show'}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" >
                    <div className="modal-dialog modal-large" role="document">
                        <div className="modal-content  theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Price exchange" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button id="ppvCloseModelUp" type="button" className='bg-transparent theme-text-color' onClick={handlePriceModalClose} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                {/* <div className="d-flex justify-content-between mb-2 col-8 me-auto">
                  <div className="col-12 col-md-6 pe-2">
                    <MessageSubHeading text={labelDisplay?.[61]?.sub_title} />
                  </div>
                  <div className="col-12 col-md-6 ps-2 text-end">
                    <AdminSwitch id="globalPPVCheckbox" name={'global_ppv'} checked={formData?.global_ppv == 1} onChange={handleInput} />
                  </div>
                </div> */}

                                <div className="row mx-0 align-items-start mb-3 ">
                                    <div className="col-12 col-md-5 ps-0 ">
                                        <MessageLabel text={`${formData?.global_ppv == 0 ? labelDisplay?.[60]?.title : labelDisplay?.[59]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                                        <AdminCustomInput isReadonly={formData?.global_ppv == 1} type="number" id="countryPPVPrice" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please enter ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />
                                    </div>
                                    <div className="col-12 col-md-5 ">
                                        <MessageLabel text={`${labelDisplay?.[62]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                                        <AdminCustomSelect id="countryPPVIOSPrice" name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                                    </div>
                                    <div className="col-12 col-md-2 pe-0 align-self-center mt-4">
                                        <AdminCustomButton id="covertPriceButton" className='px-3 py-1 m-0' saveMethod={() => handleCovertPrice(formData?.ppv_price)} saveText='Convert' />
                                    </div>
                                </div>
                                <div className="priceTable rounded-3  ">
                                    <table class="table rounded-3  position-relative">
                                        <thead className="theme-bg-color-secondary  z-index-1">
                                            <tr>
                                                <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Country</th>
                                                <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Current Price</th>
                                                <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Converted Price</th>
                                                {/* <th scope="col">Converted IOS Price</th> */}
                                                <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Difference</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {convertPrice?.convertedPriceRates?.length ? convertPrice?.convertedPriceRates.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="" scope="row">{`${item?.Country} (${item?.Code})`}</td>
                                                    <td className="">{item.Symbol} {item?.price || item?.ActualPrice}</td>
                                                    <td className=""> <AdminCustomInput id="priceChangeInput" isReadonly={formData?.global_ppv == 1} type="text" name="price" value={item?.ConvertedPriceRate} onChange={(e) => handlePriceChangeInput(e, index)} placeHolder={"Fill the custom price"} noMargin noBorder={formData?.global_ppv == 1} className={`${formData?.global_ppv == 1 && 'border-0'}`} /> </td>
                                                    <td className="">{item?.RateDifference}</td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan={4} className="errorred text-center">* Please update the pricing according to the specific market in each currency !.</td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer  border-0">
                                <button id="ppvCloseModelDown" type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={handlePriceModalClose} ><MessageBox text="Cancel" /> </button>
                                <AdminCustomButton id="countryPriceSubmitButton" className='px-3 py-1 m-0 ' saveMethod={handlePriceModal} saveText='Done' />
                            </div>
                        </div>
                    </div>
                </div>}
            <AdminBackNavigation path={`/radio-station`} text="Back" />

            {id != null ?
                <AdminSaveHeader heading={!id ? labelDisplay?.[0]?.title : labelDisplay?.[2]?.title} saveText={!id ? labelDisplay?.[0]?.title : labelDisplay?.[44]?.title} saveMethod={handleStore} id={"live-preview-button"} link={navigateChecker(languageCodeData, siteTheme, `music/radio`)} />
                : <AdminSaveHeader heading={!id ? labelDisplay?.[0]?.title : labelDisplay?.[2]?.title} saveText={!id ? labelDisplay?.[42]?.title : labelDisplay?.[57]?.title} saveMethod={handleStore} id={"live-store-button"} />
            }

            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={!id ? labelDisplay?.[0]?.title : formData?.title} />
                        <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                        <MessageSubHeading text={labelDisplay?.[3]?.sub_title} />
                        <AdminCustomInput id={"live-title"} type="text" name="title" value={formData?.title} onChange={handleInput} placeHolder={"Title"} ref={(el) => (combinedRef.current.title = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.title} />

                        <MessageLabel text={labelDisplay?.[4]?.title} className="mandatorySimple" />
                        <MessageSubHeading text={labelDisplay?.[4]?.sub_title} />
                        <AdminCustomInput id={"live-slug"} type="text" name="slug" value={formData?.slug} ref={(el) => (combinedRef.current.slug = el)} onChange={handleInput} placeHolder={"Slug"} error={formDataError?.slug} />

                        {showModal && (<AdminAIModal modalDescription="Suggest AI" modalHeading="Generate Content" modelClose={showModal} sliderClose={closeModal} applySuggestion={confirmToggle} generateSuggestion={generateSuggestion} defaultPrompt={defaultPrompt} />)}
                        <MessageLabel text={labelDisplay?.[5]?.title} enableAI handleAIModal={() => handleModal("description")} />
                        <MessageSubHeading text={labelDisplay?.[5]?.sub_title} />
                        <AdminCustomArea id={"live-description"} type="text" name="description" value={formData?.description} onChange={handleInput} ref={(el) => (combinedRef.current.description = el)} placeHolder={"description"} rows={5} maxLength={"250"} />

                        <MessageLabel text={labelDisplay?.[6]?.title} enableAI handleAIModal={() => handleModal("details")} />
                        <MessageSubHeading text={labelDisplay?.[6]?.sub_title} />
                        <JoditEditor id={"live-details"} className="mb-3" ref={(el) => (combinedRef.current.details = el)} value={formData?.details} onChange={(newContent) => setFormData(prev => ({ ...prev, details: newContent }))} />

                        {customFieldValues?.length > 0 && (


                            <div className="card p-3 mt-3">
                                {/* <MessageHeading text="Additional Fields" /> */}
                                {/* Custom fields */}
                                <FieldRenderer2
                                    pageIdentifier={id ? "radio-station.edit" : "radio-station.create"}
                                    entityType={"radio-station"}
                                    entityId={id}
                                    text="Additional Fields"
                                />
                                <FieldRenderer
                                    pageIdentifier={id ? "radio-station.edit" : "radio-station.create"}
                                    entityType={"radio-station"}
                                    entityId={id}
                                    onChange={setCustomFieldValues}
                                />


                            </div>


                        )}

                    </Wrapper>


                    <Wrapper>
                        <MessageHeading text="Duration Settings" />

                        <MessageLabel text={labelDisplay?.[7]?.title} />
                        <MessageSubHeading text={labelDisplay?.[7]?.sub_title} />
                        <AdminCustomInput id={"live-duration"} type="text" maxLength="6" name="duration" value={formData?.duration} ref={(el) => (combinedRef.current.duration = el)} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.duration} />

                        {/* {formData?.url_type !== "embed_url" && (
                            <>
                                <div className="d-flex justify-content-between mb-2 mt-3">
                                    <div className="col-6 col-md-6 pe-2">
                                        <MessageLabel text="Enable Free Duration" className={formData?.free_duration_status ? "mandatorySimple" : ""} />
                                    </div>
                                    <div className="col-6 col-md-6 ps-2 text-end">
                                        <AdminSwitch id={"live-free-duration-status"} name="free_duration_status" checked={formData?.free_duration_status} onChange={handleInput} />
                                    </div>
                                </div>

                                {formData?.free_duration_status == 1 && <>
                                    <MessageLabel text="Free Duration Time" />
                                    <MessageSubHeading text="Enter the free duration time" />
                                    <AdminCustomInput id={"live-free-duration-time"} ref={(el) => (combinedRef.current.free_duration_time = el)} type="text" maxLength="6" name="free_duration_time" value={formData?.free_duration_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.free_duration_time} />
                                </>}
                            </>
                        )} */}

                    </Wrapper>

                    {/* {(getGeofencing === "ON" || getGeofencingAvailableCountries === 1) && (
                        <Wrapper>
                            <MessageHeading text={labelDisplay?.[48]?.title || "Geo-Fencing"} />
                            {getGeofencing === "ON" && (
                                <>
                                    <MessageLabel text={labelDisplay?.[15]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[15]?.sub_title} />
                                    <Select
                                        id="live-blockCountry"
                                        options={defaultOption?.blockCountryOption?.filter(
                                            (blockedItem) => !formData?.selected_available_country?.some(
                                                (availableItem) => availableItem?.value === blockedItem?.value
                                            )
                                        )}
                                        isMulti
                                        name="selected_blocked_country"
                                        onChange={handleMultiSelect}
                                        value={formData?.selected_blocked_country}
                                        className="custom-select-multi custom-placeholder theme-text-color mb-3"
                                    />
                                </>
                            )}

                            {getGeofencingAvailableCountries === 1 && (
                                <>
                                    <MessageLabel text={labelDisplay?.[16]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[16]?.sub_title} />
                                    <Select
                                        id="live-availableCountry"
                                        options={defaultOption?.availableCountryOption?.filter(
                                            (AvailableItem) => !formData?.selected_blocked_country?.some(
                                                (blockedItem) => blockedItem?.value === AvailableItem?.value
                                            )
                                        )}
                                        isMulti
                                        name="selected_available_country"
                                        onChange={handleMultiSelect}
                                        value={formData?.selected_available_country}
                                        className="custom-select-multi custom-placeholder theme-text-color mb-3"
                                    />
                                </>
                            )}
                        </Wrapper>
                    )} */}

                    {/* <Wrapper>
                        <MessageHeading text={labelDisplay?.[40]?.title} />
                        <MessageLabel text={labelDisplay?.[41]?.title} />
                        <MessageSubHeading text={labelDisplay?.[41]?.sub_title} />
                        <TagsInput id={"live-searchTags"} name="search_tags" value={formData?.search_tags} separators={["Enter", ","]} classNames={{ tag: "custom-search-tag", input: "w-100" }} onChange={handleTagsChange} />
                    </Wrapper> */}

                    <Wrapper>
                        <MessageHeading text="Categories" />
                        <div className="d-flex justify-content-between align-items-start">
                            <div className="pe-2">
                                <MessageLabel text="Radio Station Categories" className="mandatorySimple" />
                                <MessageSubHeading text="Select the categories for this radio station" />
                            </div>
                            <button type="button" className="vjs-big-play-button rounded" onClick={() => setCategoryModal(true)} title="Add Category">
                                <MdAddCircle style={{ width: "20px", height: "20px" }} />
                            </button>
                        </div>
                        <RadioCategoryMultiSelect
                            options={defaultOption?.categoryOption}
                            value={formData.selected_categories || []}
                            onChange={(vals) => setFormData(p => ({ ...p, selected_categories: vals }))}
                            containerRef={(el) => (combinedRef.current.selected_categories = el)}
                        />
                        {formDataError?.selected_categories && (
                            <MessageBox text={`${formDataError?.selected_categories}`} classname='errorred mb-2 d-block' />
                        )}
                    </Wrapper>

                    {/* {page_for == "edit" &&
                        <Wrapper>
                            <MessageHeading text={labelDisplay?.[36]?.title} />

                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-6 col-md-6 pe-2">
                                    <MessageLabel text={labelDisplay?.[38]?.title} />
                                </div>
                                <div className="col-6 col-md-6 ps-2 text-end">
                                    <AdminSwitch id={"live-active"} name={'active'} checked={formData?.active == 1} onChange={handleInput} />
                                </div>
                            </div>
                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-6 col-md-6 pe-2">
                                    <MessageLabel text={labelDisplay?.[39]?.title} />
                                </div>
                                <div className="col-6 col-md-6 ps-2 text-end">
                                    <AdminSwitch id={"live-banner"} name={'banner'} checked={formData?.banner == 1} onChange={handleInput} />
                                </div>
                            </div>
                        </Wrapper>
                    } */}

                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[32]?.title} />

                        <MessageLabel text={labelDisplay?.[33]?.title} />
                        <MessageSubHeading text={labelDisplay?.[33]?.sub_title} />
                        <AdminCustomInput id={"live-websitePageTitle"} type="text" name="website_page_title" value={formData?.website_page_title} ref={(el) => (combinedRef.current.website_page_title = el)} onChange={handleInput} placeHolder={"Please enter Website title"} error={formDataError?.website_page_title} />

                        <MessageLabel text={labelDisplay?.[34]?.title} />
                        <MessageSubHeading text={labelDisplay?.[34]?.sub_title} />
                        <AdminCustomInput id={"live-websiteUrl"} type="text" name="website_URL" value={formData?.website_URL} onChange={handleInput} placeHolder={"Please enter Website url"} ref={(el) => (combinedRef.current.website_URL = el)} error={formDataError?.website_URL} />

                        <MessageLabel text={labelDisplay?.[35]?.title} />
                        <MessageSubHeading text={labelDisplay?.[35]?.sub_title} />
                        <AdminCustomArea id={"live-metaDescription"} type="text" name="Meta_description" value={formData?.Meta_description} onChange={handleInput} ref={(el) => (combinedRef.current.Meta_description = el)} placeHolder={"Please enter Meta description"} rows={5} />
                    </Wrapper>

                </LeftWrapper>
                <RightWrapper>

                    <Wrapper>
                        <MessageHeading text={`Audio ${formData?.url_type?.replace(/_/g, " ")}`} />
                        {formData?.url_type == 'embed_url' ? (

                            <iframe className="w-100" src={formData?.embed_url}
                                poster={formData?.player_image} frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen>
                            </iframe>
                        ) : (
                            <audio controls className="w-100">
                                <source src={formData?.audio_url} />
                            </audio>
                        )}
                    </Wrapper>

                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[26]?.title} />
                        <MessageLabel text={labelDisplay?.[27]?.title} />
                        <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[27]?.sub_title, 'portrait')} />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={coverImageFile}
                            uploadedImage={formData?.image}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.image = el)}
                            name="image"
                            orientationSlug="portrait"
                            id={"live-cover-image"}
                            error={formDataError?.image}
                        />
                        <MessageLabel text={labelDisplay?.[28]?.title} />
                        <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[28]?.sub_title, 'landscape')} />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={playerImageFile}
                            uploadedImage={formData?.player_image}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.player = el)}
                            name="player"
                            orientationSlug="landscape"
                            id={"live-player-image"}
                            error={formDataError?.player}

                        />
                        <MessageLabel text={labelDisplay?.[29]?.title} />
                        <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[29]?.sub_title, 'landscape')} />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={tvImageFile}
                            uploadedImage={formData?.Tv_live_image}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.tv = el)}
                            name="tv"
                            orientationSlug="landscape"
                            error={formDataError?.tv}
                            id={"live-tv-image"}
                        />
                        <MessageLabel text="Player Cover Image (Square)" />
                        <MessageSubHeading text={"Select the radio station player cover image ( 1:1 Ratio or 1080px X 1080px)"} />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={playerCoverImageFile}
                            uploadedImage={formData?.radio_station_player_cover}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.player_cover = el)}
                            name="player_cover"
                            orientationSlug="square"
                            error={formDataError?.player_cover}
                            id={"live-player-cover-image"}
                        />

                    </Wrapper>

                    <Wrapper>
                        <MessageHeading text="Radio Source" />
                        <MessageLabel text="Audio Source" className="mandatorySimple" />
                        <MessageSubHeading text="Choose the radio station audio source type" />
                        <AdminCustomSelect ref={(el) => (combinedRef.current.url_type = el)} name="url_type" value={formData?.url_type} defaultValue={formData?.url_type} onChange={handleInput}
                            options={defaultOption?.radioSourceOption || [
                                { name: "Embed URL", value: "embed_url" },
                                { name: "MP3 Audio File Upload", value: "mp3_audio_upload" },
                                { name: "AAC Audio File Upload", value: "aac_audio_upload" },
                                { name: "MP3 Audio URL", value: "mp3_url" },
                                { name: "AAC Audio URL", value: "aac_url" }
                            ]}
                            error={formDataError?.url_type} defaultOptionName={"Choose Audio Source"} label={"name"} id={"radio-url-type"} />

                        {formData?.url_type == "embed_url" && <AdminCustomInput id={"radio-embed-url"} type="text" name="embed_url" value={formData?.embed_url} ref={(el) => (combinedRef.current.embed_url = el)} onChange={handleInput} placeHolder={"Please enter embed URL for radio player"} error={formDataError?.embed_url} />}

                        {formData?.url_type == "mp3_url" && <AdminCustomInput id={"radio-mp3-url"} type="text" name="m3u_url" value={formData?.m3u_url} ref={(el) => (combinedRef.current.m3u_url = el)} onChange={handleInput} placeHolder={"Please enter MP3 stream URL"} error={formDataError?.m3u_url} />}

                        {formData?.url_type == "aac_url" && <AdminCustomInput id={"radio-aac-url"} type="text" name="acc_audio_url" value={formData?.acc_audio_url} ref={(el) => (combinedRef.current.acc_audio_url = el)} onChange={handleInput} placeHolder={"Please enter AAC stream URL"} error={formDataError?.acc_audio_url} />}

                        {(formData?.url_type == "mp3_audio_upload" || formData?.url_type == "aac_audio_upload") &&
                            <>
                                <input
                                    className="form-control w-100 h-100"
                                    id="radio-audio-upload"
                                    type="file"
                                    accept={formData?.url_type == "mp3_audio_upload" ? "audio/mp3, audio/mpeg" : "audio/aac, audio/x-aac, audio/mp4, .aac"}
                                    onChange={(e) => handleLibraryChange(e)}
                                />
                                <AdminCustomButton id="radio-choose-library" saveMethod={handleToggleGalleryModel} saveText="Choose from library" className="mt-3" />
                                {selectedIds?.length ? <MessageLabel text={"You have selected an audio file from library"} /> : ""}
                            </>
                        }

                    </Wrapper>

                    {/* <Wrapper>
                        <MessageHeading text={labelDisplay?.[30]?.title} />
                        <MessageLabel text={labelDisplay?.[31]?.title} className="mandatorySimple" />
                        <MessageSubHeading text={labelDisplay?.[31]?.sub_title} />
                        <AdminCustomSelect id={"live-access"} name="access" value={formData?.access || 0} onChange={handleInput} ref={(el) => (combinedRef.current.access = el)} options={defaultOption?.accessOption?.map((item) => ({ name: item?.name, value: item?.value }))} error={formDataError?.access} defaultOptionName={"Choose an user access"} />
                        {formData?.access === "ppv" && <>
                            {globalPpvStatusActive?.PPV_Individual_Contents == 0 ?
                                (
                                    <div className="mt-3">
                                        <MessageLabel text={labelDisplay?.[61]?.title} />
                                        <div className="d-flex justify-content-between mb-2 ">
                                            <div className="col-6 col-md-6 pe-2">
                                                <MessageSubHeading text={labelDisplay?.[61]?.sub_title} />
                                            </div>
                                            <div className="col-6 col-md-6 ps-2 text-end">
                                                <AdminSwitch id={"live-global-ppv"} name={'global_ppv'} checked={formData?.global_ppv == 1} onChange={handleInput} />
                                            </div>
                                        </div>
                                        <AdminCustomInput id={"live-ppv-price"} isReadonly={formData?.global_ppv == 1} type="text" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please enter ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />
                                        <MessageLabel text={labelDisplay?.[62]?.title} />
                                        <AdminCustomSelect id={"live-ios-ppv-price"} name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                                    </div>
                                )
                                :
                                <div className="mt-3">
                                    <AdminCustomButton id="video-custom-ppv-button" saveMethod={() => handlePriceModal()} saveText="Customize PPV" className="d-block ms-auto mt-3" />
                                </div >
                            }
                        </>}
                    </Wrapper > */}

                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[36]?.title} />

                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={labelDisplay?.[38]?.title} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch id={"live-active"} name={'active'} checked={formData?.active == 1} onChange={handleInput} />
                            </div>
                        </div>
                    </Wrapper>

                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[49]?.title} />
                        <MessageLabel text={labelDisplay?.[49]?.title} />
                        <div className='d-flex align-items-center justify-content-start gap-3 mt-3'>
                            <AdminCustomRadio id={"live-publish-now"} name="publish_now" checked={formData?.publish_type == "publish_now"} onChange={handleInput} />
                            <MessageLabel text={labelDisplay?.[50]?.title} noMargin className={formData?.publish_type == "publish_now" ? "mandatorySimple" : ""} />
                        </div>
                        {formData?.publish_type == "publish_now" && (<>
                            {/* <MessageLabel text={labelDisplay?.[7]?.title} /> */}
                            <AdminCustomSelect id={"live-year"} name="year" value={formData?.year} onChange={handleInput} ref={(el) => (combinedRef.current.year = el)} options={years} error={formDataError?.year} defaultOptionName="Choose publish year" />
                        </>)}
                        <div className='d-flex align-items-center justify-content-start gap-3 mt-3'>
                            <AdminCustomRadio id={"live-publish-later"} name="publish_later" checked={formData?.publish_type == "publish_later"} onChange={handleInput} />
                            <MessageLabel text={labelDisplay?.[51]?.title} noMargin className={formData?.publish_type == "publish_later" ? "mandatorySimple" : ""} />
                        </div>

                        {formData?.publish_type == "publish_later" && (<>
                            <AdminCustomInput id={"live-publish-time"} min={new Date().toISOString().slice(0, 16)} type="datetime-local" name="publish_time" value={formData?.publish_time} onChange={handleInput} placeHolder={"time "} ref={(el) => (combinedRef.current.publish_time = el)} error={formDataError?.publish_time} />
                        </>)}
                    </Wrapper>


                </RightWrapper >
            </FormContainer >


            <div className="mt-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <MessageHeading text={labelDisplay?.[17]?.title || "Schedule Programs"} />
                        <MessageSubHeading text={`Total Programs: ${formData?.schedule_programs?.length || 0}`} className="text-muted" />
                    </div>
                    <div>
                        <AdminCustomButton
                            id="add-schedule-program"
                            className="btn-success px-4 py-2"
                            saveMethod={handleAddScheduleProgram}
                            saveText={labelDisplay?.[24]?.title || "+ Add Program"}
                        />
                    </div>
                </div>

                {formData?.schedule_programs?.map((program, index) => (
                    <div key={program.id} className="border rounded-3 p-3 mb-4 position-relative" style={{ backgroundColor: '#f8f9fa' }}>
                        {/* Program Header with Remove Button */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="d-flex align-items-center">
                                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                                    style={{ width: '32px', height: '32px', fontSize: '14px', fontWeight: 'bold' }}>
                                    {index + 1}
                                </div>
                                <h6 className="mb-0 fw-bold">Program {index + 1}</h6>
                                {program.start_time && program.end_time && (
                                    <span className="badge bg-info ms-2">
                                        {program.start_time} - {program.end_time}
                                        {(() => {
                                            const start = new Date(`1970-01-01T${program.start_time}:00`);
                                            const end = new Date(`1970-01-01T${program.end_time}:00`);
                                            const diffMs = end - start;
                                            const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
                                            const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                                            return ` (${diffHours}h ${diffMins}m)`;
                                        })()}
                                    </span>
                                )}
                            </div>
                            {formData?.schedule_programs?.length > 1 && (
                                <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm d-flex align-items-center"
                                    onClick={() => handleRemoveScheduleProgram(program.id)}
                                    title="Remove this program"
                                >
                                    <IoClose size={16} className="me-1" />
                                    {labelDisplay?.[25]?.title || "Remove"}
                                </button>
                            )}
                        </div>

                        <div className="row">
                            <LeftWrapper>
                                <Wrapper>
                                    <MessageLabel text={labelDisplay?.[18]?.title || "Program Name"} className="mandatorySimple" />
                                    <AdminCustomInput
                                        id={`schedule-program-name-${program.id}`}
                                        type="text"
                                        name={`schedule_program_${program.id}_name`}
                                        value={program.name}
                                        onChange={(e) => handleScheduleProgramChange(program.id, 'name', e.target.value)}
                                        placeHolder="Enter program name"
                                        error={formDataError?.[`schedule_program_${program.id}_name`]}
                                    />

                                    <MessageLabel text={labelDisplay?.[19]?.title || "Program Description"} className="mandatorySimple" />
                                    <AdminCustomArea
                                        id={`schedule-program-description-${program.id}`}
                                        type="text"
                                        name={`schedule_program_${program.id}_description`}
                                        value={program.description}
                                        onChange={(e) => handleScheduleProgramChange(program.id, 'description', e.target.value)}
                                        placeHolder="Enter program description"
                                        rows={3}
                                        maxLength={"250"}
                                        error={formDataError?.[`schedule_program_${program.id}_description`]}
                                    />
                                    <small className="text-muted">{program.description?.length || 0}/250 characters</small>

                                    <MessageLabel text={labelDisplay?.[22]?.title || "Days"} />
                                    <Select
                                        id={`schedule-program-days-${program.id}`}
                                        options={[
                                            { value: 'monday', label: 'Monday' },
                                            { value: 'tuesday', label: 'Tuesday' },
                                            { value: 'wednesday', label: 'Wednesday' },
                                            { value: 'thursday', label: 'Thursday' },
                                            { value: 'friday', label: 'Friday' },
                                            { value: 'saturday', label: 'Saturday' },
                                            { value: 'sunday', label: 'Sunday' }
                                        ]}
                                        isMulti
                                        name={`schedule_program_${program.id}_days`}
                                        value={program.selectedDays || []}
                                        onChange={(selectedOptions) => {
                                            handleScheduleProgramChange(program.id, 'selectedDays', selectedOptions);
                                            const daysString = selectedOptions ? selectedOptions.map(option => option.label).join(', ') : '';
                                            handleScheduleProgramChange(program.id, 'days', daysString);
                                        }}
                                        className="custom-select-multi custom-placeholder theme-text-color mb-3"
                                        placeholder="Select broadcasting days..."
                                        closeMenuOnSelect={false}
                                        error={formDataError?.[`schedule_program_${program.id}_days`]}
                                    />
                                    {formDataError?.[`schedule_program_${program.id}_days`] && (<MessageBox text={`${formDataError?.[`schedule_program_${program.id}_days`]}`} classname='errorred mb-2 d-block' />)}
                                </Wrapper>
                            </LeftWrapper>

                            <RightWrapper>
                                <Wrapper>
                                    <div className="row">
                                        <div className="col-12 col-md-6 mb-3">
                                            <MessageLabel text={labelDisplay?.[20]?.title || "Start Time"} className="mandatorySimple" />
                                            <AdminCustomInput
                                                id={`schedule-program-start-time-${program.id}`}
                                                type="time"
                                                name={`schedule_program_${program.id}_start_time`}
                                                value={program.start_time}
                                                onChange={(e) => handleScheduleProgramChange(program.id, 'start_time', e.target.value)}
                                                error={formDataError?.[`schedule_program_${program.id}_start_time`]}
                                            />
                                        </div>

                                        <div className="col-12 col-md-6 mb-3">
                                            <MessageLabel text={labelDisplay?.[21]?.title || "End Time"} className="mandatorySimple" />
                                            <AdminCustomInput
                                                id={`schedule-program-end-time-${program.id}`}
                                                type="time"
                                                name={`schedule_program_${program.id}_end_time`}
                                                value={program.end_time}
                                                onChange={(e) => handleScheduleProgramChange(program.id, 'end_time', e.target.value)}
                                                error={formDataError?.[`schedule_program_${program.id}_end_time`]}
                                            />
                                        </div>
                                    </div>

                                    <MessageLabel text={labelDisplay?.[23]?.title || "Program Image (Optional)"} />
                                    <AdminImageUploadZone
                                        onChange={(e) => {
                                            console.log('AdminImageUploadZone onChange triggered:', {
                                                programId: program.id,
                                                fileSelected: e.target.files?.length > 0,
                                                fileName: e.target.files?.[0]?.name
                                            });
                                            handleScheduleImageChange(e, program.id);
                                        }}
                                        selectedFile={scheduleImageFiles[program.id]}
                                        uploadedImage={program.image}
                                        onDelete={() => handleClearScheduleImage(program.id)}
                                        name={`schedule_program_${program.id}_image`}
                                        id={`schedule-program-image-${program.id}`}
                                        error={formDataError?.[`schedule_program_${program.id}_image`]}
                                    />
                                </Wrapper>
                            </RightWrapper>
                        </div>
                    </div>
                ))}
            </div>


            <FormContainer>
                <AdminCustomButton id="add-schedule-program-bottom" className="btn-success px-4 py-2" saveMethod={handleAddScheduleProgram} saveText="+ Add Another Program" />
                <AdminCustomButton id={"live-store-button"} className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={!id ? labelDisplay?.[1]?.title : labelDisplay?.[44]?.title} />
            </FormContainer>


        </div >
    );
};

const mapStateToProps = (state) => ({
    siteTheme: state.siteTheme.siteTheme,
    languageCodeData: state.languageCode.languageCodeData
});

export default connect(mapStateToProps)(AddEditRadioStation);

function RadioCategoryMultiSelect({ options, value = [], onChange, containerRef }) {
    const [open, setOpen] = React.useState(false);
    const [searchQuery, setSearchQuery] = React.useState("");
    const localRef = React.useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (localRef.current && !localRef.current.contains(event.target)) {
                setOpen(false);
                setSearchQuery("");
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const toggle = (id) => {
        if (value.includes(id)) {
            onChange(value.filter(v => v !== id));
        } else {
            onChange([...value, id]);
        }
    };

    const filterTree = (nodes, query) => {
        if (!query) return nodes;
        const lowerQuery = query.toLowerCase();
        return (nodes || [])
            .map(node => {
                const matchesSelf = node.name?.toLowerCase().includes(lowerQuery);
                if (matchesSelf) return node;
                const subCat = node.sub_category || node.sub_categories || [];
                const children = subCat.length > 0 ? filterTree(subCat, query) : [];
                if (children.length > 0) {
                    const updatedNode = { ...node };
                    if (node.sub_category) updatedNode.sub_category = children;
                    else updatedNode.sub_categories = children;
                    return updatedNode;
                }
                return null;
            })
            .filter(Boolean);
    };

    const filteredOptions = filterTree(options, searchQuery);

    return (
        <div ref={(el) => { localRef.current = el; if (containerRef) containerRef(el); }} className="relative w-full">
            <div
                className="custom-input-border custom-input theme-text-color cursor-pointer mb-3"
                onClick={(e) => { e.stopPropagation(); setOpen(o => !o); }}
            >
                {value.length ? `${value.length} categories selected` : "Choose categories"}
            </div>
            {open && (
                <div className="absolute bg-white border shadow z-50 mt-1 max-h-80 overflow-auto w-full" style={{ padding: "8px 12px" }}>
                    <input
                        type="text"
                        placeholder="Search categories..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                        className="form-control mb-2"
                        style={{ width: '100%', padding: '6px 12px', fontSize: '13px', border: '1px solid rgba(128,128,128,0.3)', borderRadius: '4px', outline: 'none', backgroundColor: 'transparent', color: 'inherit' }}
                    />
                    {filteredOptions.length === 0 ? (
                        <p className="theme-text-color opacity-50 p-2" style={{ fontSize: 13, margin: 0 }}>No categories found</p>
                    ) : (
                        <RadioCategoryTreeCheckbox options={filteredOptions || []} selected={value} onToggle={toggle} level={0} />
                    )}
                </div>
            )}
        </div>
    );
}

function RadioCategoryTreeCheckbox({ options, selected, onToggle, level }) {
    if (!options || !Array.isArray(options)) return null;
    return (
        <ul>
            {options.map(item => (
                <li key={item.id}>
                    <label
                        className="custom-input theme-text-color d-flex items-center gap-2 py-1 cursor-pointer"
                        style={{ paddingLeft: level * 16 }}
                    >
                        <input type="checkbox" checked={selected.includes(item.id)} onChange={() => onToggle(item.id)} />
                        {item.name}
                    </label>
                    {item.sub_category?.length > 0 && (
                        <RadioCategoryTreeCheckbox options={item.sub_category} selected={selected} onToggle={onToggle} level={level + 1} />
                    )}
                    {item.sub_categories?.length > 0 && (
                        <RadioCategoryTreeCheckbox options={item.sub_categories} selected={selected} onToggle={onToggle} level={level + 1} />
                    )}
                </li>
            ))}
        </ul>
    );
}